import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import classes from '../../subcategories-links.scss';
const RenderCategory = ({
  currentSubcategoryId,
  currentRoute,
  parentCategory,
  isViolet,
  onLinkClick,
  subcategories,
  hidden,
  isFirstFocused,
  onKeyDown
}) => {
  const contentRef = React.useRef(null);
  React.useEffect(() => {
    var _contentRef$current;
    if (!(contentRef !== null && contentRef !== void 0 && contentRef.current) || !(contentRef !== null && contentRef !== void 0 && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.firstChild)) {
      return;
    }
    if (isFirstFocused) {
      contentRef.current.firstChild.focus();
    }
  }, [isFirstFocused]);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.content, {
      [classes.nonVisible]: hidden
    }),
    ref: contentRef
  }, /*#__PURE__*/React.createElement(Link, {
    className: classnames(classes.subMenuItem, {
      [classes.activeMenuItem]: currentSubcategoryId === null,
      [classes.violet]: isViolet
    }),
    to: urlModifier(`${currentRoute}/${parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.slug}`),
    onClick: () => onLinkClick(currentSubcategoryId === null),
    onKeyDown: onKeyDown
  }, /*#__PURE__*/React.createElement("span", null, `All ${parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.name}`)), (subcategories || []).map(subcat => {
    if (!subcat.isVisible) {
      return null;
    }
    const isActive = subcat._id === currentSubcategoryId;
    return /*#__PURE__*/React.createElement(Link, {
      key: subcat._id,
      className: classnames(classes.subMenuItem, {
        [classes.activeMenuItem]: isActive,
        [classes.violet]: isViolet
      }),
      to: urlModifier(`${currentRoute}/${subcat.slug}`),
      onClick: () => onLinkClick(isActive),
      onKeyDown: onKeyDown
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.linkName
    }, subcat.name));
  }));
};
export const TextCategories = ({
  currentSubcategoryId,
  currentRoute,
  parentCategory,
  isViolet,
  onLinkClick,
  subcategories,
  shouldShow,
  allSubcategories,
  isFirstFocused,
  onKeyDown
}) => {
  if (allSubcategories !== null && allSubcategories !== void 0 && allSubcategories.length) {
    return /*#__PURE__*/React.createElement(RenderCategory, {
      currentSubcategoryId: currentSubcategoryId,
      currentRoute: currentRoute,
      parentCategory: parentCategory,
      isViolet: isViolet,
      onLinkClick: onLinkClick,
      subcategories: allSubcategories,
      hidden: true,
      isFirstFocused: isFirstFocused,
      onKeyDown: onKeyDown
    });
  }
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RenderCategory, {
    currentSubcategoryId: currentSubcategoryId,
    currentRoute: currentRoute,
    parentCategory: parentCategory,
    isViolet: isViolet,
    onLinkClick: onLinkClick,
    subcategories: subcategories,
    hidden: false,
    isFirstFocused: isFirstFocused,
    onKeyDown: onKeyDown
  });
};